import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import "babel-polyfill";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './assets/mock/mock.js'
// 引入自定义增强插件
// import plugins from './plugins/plugins.js'
const vue = createApp(App);
// 前置路由守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
vue.config.globalProperties.axios = axios;
axios.defaults.baseURL = 'http://47.104.169.175:81/';
// axios.defaults.baseURL = 'http://127.0.0.1:81/';
vue.use(store).use(router).use(ElementPlus).mount('#app');
// 添加请求拦截器
axios.interceptors.request.use((config)=>{
	// 添加header头的token
	let token = window.sessionStorage.getItem('token')
	if(token){
		config.headers.common['token'] = token
	}else{
		config.headers.common['token'] = ''
	}
	// 在发送请求之前做些什么
	return config;
}, (error)=> {
	// 对请求错误做些什么
	return Promise.reject(error);
})

// 添加响应拦截器
axios.interceptors.response.use((response)=>{
	if(response.data.code == 50001){
		$store.state.commit('logout')
		router.push('/')
	}
	return response;
},(err)=> {
	// 全局错误提示
	if(err.response && err.response.data && err.response.data.errorCode){
		Message.error(err.response.data.msg)
	}
	// 对响应错误做点什么
	return Promise.reject(err);
});

